function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { UncontrolledCheckbox } from "./UncontrolledCheckbox";

/*
    Returns a controlled checkbox that is based on an uncontrolled checkbox

    props
        (function)  onChange                       Called when the checkbox is toggled
        (boolean)   checked                        When true, the checkbox is checked
        (component) UncontrolledCheckboxComponent  The uncontrolled checkbox to use as the base for the controlled version
        (children)  children                       The content/label of the checkbox
*/

const ControlledCheckbox = ({
  onChange,
  checked,
  name = "",
  UncontrolledCheckboxComponent = UncontrolledCheckbox,
  children,
  ...rest
}) => {
  const handleOnChange = () => {
    onChange({
      name,
      value: !checked
    });
  };
  return /*#__PURE__*/React.createElement(UncontrolledCheckboxComponent, _extends({
    onChange: handleOnChange,
    checked: checked
  }, rest), children);
};
export { ControlledCheckbox };